import Vue from 'vue'
import VueRouter, { RouteConfig } from 'vue-router'
import Home from '@/components/landing-pages/Home.vue'
import {auth} from 'firebase/app'
import store from '@/store'

Vue.use(VueRouter)

const routes: Array<RouteConfig> = [
  {
    path: '/',
    name: 'Home',
    component: Home,
    meta: {
      breadcrumb: 'Home'
    }
  },
  {
    path: '/about',
    name: 'About',
    component: () => import(/* webpackPrefetch: true */ '../components/landing-pages/About.vue'),
    meta: {
      transitionName: 'slide',
      requiresAuth: false
    }
  },
  {
    path: '/design',
    name: 'Design',
    component: () => import(/* webpackPrefetch: true */ '../components/landing-pages/Design.vue'),
    meta: {
      transitionName: 'slide',
      requiresAuth: false
    }
  },
  {
    path: '/contact',
    name: 'Contact',
    component: () => import(/* webpackPrefetch: true */ '../components/landing-pages/Contact.vue'),
    meta: {
      transitionName: 'slide',
      requiresAuth: false
    }
  },

  {
    path: '/test',
    name: 'Test',
    component: () => import(/* webpackPrefetch: true */ '../components/landing-pages/Test.vue'),
    meta: {
      transitionName: 'slide',
      requiresAuth: true
    }
  },
  {
    path: '/blog',
    name: 'Blog',
    component: () => import(/* webpackPrefetch: true */ '../components/landing-pages/Blog.vue'),
    meta: {
      transitionName: 'slide'
    }
  },
  {
    path: '/blog/:id',
    name: 'BlogPage',
    component: () => import(/* webpackPrefetch: true */ '../components/landing-pages/BlogPost.vue'),
    props: { default: 1 },
    meta: {
      transitionName: 'slide'
    }
  },
  {
    path: '/blog/tag/:id',
    name: 'TagPage',
    component: () => import(/* webpackPrefetch: true */ '../components/landing-pages/Tags.vue'),
    meta: {
      transitionName: 'slide'
    }
  },
  {
    path: '/admin/blogmanagement',
    name: 'BlogAdmin',
    component: () => import(/* webpackPrefetch: true */ '../components/admin/admin/BlogManagementTest.vue'),
    meta: {
      transitionName: 'slide',
      requiresAuth: true,
      requiresAmin: true,
      breadcrumb: {
        label: 'Blog Admin',
        parent: 'Admin'
      }
    }
  },
  ,
  {
    path: '/admin/projects',
    name: 'ProjectsAdmin',
    component: () => import(/* webpackPrefetch: true */ '../components/admin/admin/Projects/Projects.vue'),
    meta: {
      transitionName: 'slide',
      requiresAuth: true,
      requiresAmin: true,
      breadcrumb: {
        label: 'Projects',
        parent: 'Admin'
      }
    }
  },
  {
    path: '/blog/:id/edit',
    name: 'editBlog',
    component: () => import(/* webpackPrefetch: true */ '../components/admin/admin/Blog/EditBlog.vue'),
    props: { default: 1 },
    meta: {
      transitionName: 'slide'
    }
  },
  
  {
    path: '/admin/createBlog',
    name: 'CreateBlog',
    component: () => import(/* webpackPrefetch: true */ '@/components/admin/admin/Blog/CreateBlog.vue'),
    meta: {
      transitionName: 'slide',
      requiresAuth: true,
      requiresAmin: true,
      breadcrumb: {
        label: 'Create a Blog',
        parent: 'BlogAdmin'
      }

    }
  },
  {
    path: '/admin/leads',
    name: 'Leads',
    component: () => import(/* webpackPrefetch: true */ '@/components/admin/admin/Leads/Leads.vue'),
    meta: {
      transitionName: 'slide',
      requiresAuth: true,
      requiresAmin: true,
      breadcrumb: {
        label: 'Leads',
        parent: 'Admin'
      }

    }
  },
  {
    path: '/projects',
    name: 'Projects',
    component: () => import(/* webpackPrefetch: true */ '../components/landing-pages/Projects.vue'),
    meta: { transitionName: 'slide' }
  },
  {
    path: '/profile',
    name: 'Profile',
    component: () => import(/* webpackPrefetch: true */ '../components/auth/ViewProfile.vue'),
    meta: {
      transitionName: 'slide',
      requiresAuth: true
    }
  },
  {
    path: '/signup',
    name: 'Signup',
    component: () => import(/* webpackPrefetch: true */ '../components/auth/Signup.vue'),
    meta: {
      transitionName: 'slide',
      requiresAnonymous: true
    }
  },
  {
    path: '/login',
    name: 'Login',
    component: () => import(/* webpackPrefetch: true */ '../components/auth/Login.vue'),
    meta: {
      transitionName: 'slide',
      requiresAnonymous: true
    }
  },
  {
    path: '/admin',
    name: 'Admin',
    component: () => import(/* webpackPrefetch: true */ '../components/admin/Admin.vue'),
    meta: {
      transitionName: 'slide',
      requiresAuth: true,
      requiresAdmin: true,
      breadcrumb: {
        label: 'Admin',
        parent: 'Home'
      }
    }
  },
  
  {
    path: '/superadmin',
    name: 'SuperAdmin',
    component: () => import(/* webpackPrefetch: true */ '../components/admin/SuperAdmin.vue'),
    meta: {
      transitionName: 'slide',
      requiresAuth: true,
      requiresAdmin: true,
      requiresSuperAdmin: true
    }
  },
  {
    path: '/superuser/usermanagement',
    name: 'UserManagement',
    component: () => import(/* webpackPrefetch: true */ '../components/admin/super/UserManagement.vue'),
    meta: {
      transitionName: 'slide',
      requiresAuth: true,
      requiresAdmin: true,
      requiresSuperAdmin: true,
      breadcrumb: {
        label: 'User Management',
        parent: 'Admin'
      }
    }
  },

  {
    path: '/design',
    name: 'WebsiteDesign',
    component: () => import(/* webpackPrefetch: true */ '../components/landing-pages/About.vue'),
  },
  {
    path: '/auth/notverified',
    name: 'UserNotVerified',
    component: () => import(/* webpackPrefetch: true */ '../components/auth/UserNotVerified.vue'),
    meta: {
      transitionName: 'slide'
    }
  }

]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach((to, from, next) => {
  // check to see if route requires auth
  if (to.matched.some(rec => rec.meta.requiresAuth)) {
    // check auth stae of user
    if (store.state.user) {
      // user is signed in, redirect to route
      next()
    } else {
      // no user signed in, redirect to login
      next({ name: 'Home' })
    }
  } else {
    next()
  }
  // disable nagivation to the login/signin routes if logged in
  if (to.matched.some(rec => rec.meta.requiresAnonymous)) {
    // check auth state of user
    if (!store.state.user) {
      // user is signed in, redirect to route
      next()
    } else {
      // no user signed in, redirect to login
      next({ name: 'Home' })
    }
  } else {
    next()
  }

  if (to.matched.some(rec => rec.meta.requiresAdmin)) {
    if (store.state.user) {
      auth().currentUser.getIdTokenResult()
        .then((response) => {
          if (response.claims.superadmin === true || response.claims.admin === true) {
            next()
          } else {
            // Unauthorized access, redirect to profile
            next({ name: 'Login' })
          }
        })
    } else {
      // Unauthorized acces, redirect to homepage
      next({ name: 'Login' })
    }
  }
})

export default router
